import ModalImport from 'Features/Modal/ModalImport';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {importUserExcel} from '../../service';
import {ProModalProps} from 'Components/ProModal';

export function UserImportModal({...props}: ProModalProps) {
    const [onUpload] = useRequestFn(async file => {
        await importUserExcel(file);
        props.onOk?.();
    });

    return (
        <ModalImport
            {...props}
            title="用户导入"
            onUpload={onUpload}
            templateUrl={require('./【导入模板】用户数据导入模板V0.1.xlsx')}
            templateName="数据导入模板"
            restSteps={<div>2.&nbsp;在导入模板补充好用户数据后上传文件</div>}>
            123123
        </ModalImport>
    );
}
